import { Button, Modal, TextInput } from 'flowbite-react';
import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { fetchInventoryTypes } from '../../Actions/CommonFields';
import JobApi from '../../Api/JobApi';
import Loader from '../Common/Loader';
import { JobItem } from '../../Models/JobItem';

export default function JobItemModal({
  show,
  setShow,
  jobId,
  getJobItems,
  getSchedulerData = undefined,
  selectedJobItem,
  setSelectedJobItem,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  jobId: number;
  getJobItems: () => Promise<void> | undefined;
  getSchedulerData?: () => void;
  selectedJobItem: JobItem | null;
  setSelectedJobItem: React.Dispatch<React.SetStateAction<JobItem | null>>;
}) {
  const dispatch = useAppDispatch();
  const { inventoryTypes } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<JobItem>({
    id: 0,
    jobId: jobId,
    dateOrdered: null,
    quantity: null,
    price: null,
    inventoryTypeId: null,

    inventoryType: null,
  });

  const getReferences = async () => {
    if (!inventoryTypes.length) {
      await Promise.all([dispatch(fetchInventoryTypes())]);
    }
  };

  useEffect(() => {
    getReferences();
  }, []);

  const inventoryListOptions = inventoryTypes.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: 300, // Set the width here
    }),
  };

  const handleSetInitialValues = () => {
    const values = selectedJobItem
      ? {
          ...selectedJobItem,
        }
      : {
          id: 0,
          jobId: jobId,
          dateOrdered: null,
          quantity: null,
          price: null,
          inventoryTypeId: null,

          inventoryType: null,
        };
    setFormData(values as JobItem);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedJobItem]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      jobId: jobId,
      dateOrdered: null,
      quantity: null,
      price: null,
      inventoryTypeId: null,

      inventoryType: null,
    };
    setFormData(values as JobItem);
    setButtonDisabled(false);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeSelect = async (selectedOption) => {
    const { value } = selectedOption;
    setFormData((prevData) => ({ ...prevData, inventoryTypeId: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    if (!formData.dateOrdered) {
      formData.dateOrdered = null;
    }
    return await JobApi.addUpdateJobItem(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          setButtonDisabled(false);
          handleResetFormValues();
          getJobItems();
          if (getSchedulerData) {
            getSchedulerData();
          }
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    handleResetFormValues();
    setSelectedJobItem(null);
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='w-full'>
                <div className='mx-1 flex items-end justify-center'>
                  <div className='flex flex-1 justify-center'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      {selectedJobItem ? 'Edit' : 'Add'} Item
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className='container mx-auto p-2'>
                  <div className='md:flex no-wrap md:-mx-2 '>
                    <div className='w-full'>
                      <div className='bg-white'>
                        <hr className='bg-gray-300 h-[5px]'></hr>
                        <form id='jobItemForm' onSubmit={onSubmit}>
                          <div className='text-gray-500'>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Item:
                                </div>
                              </div>
                              <div className='w-full'>
                                <Select
                                  id='inventoryTypeId'
                                  name='inventoryTypeId'
                                  onChange={handleChangeSelect}
                                  value={
                                    inventoryListOptions
                                      ? inventoryListOptions.find(
                                          (x) =>
                                            x.value === formData.inventoryTypeId
                                        )
                                      : ''
                                  }
                                  required
                                  options={inventoryListOptions}
                                  styles={customStyles}
                                ></Select>
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Quantity:
                                </div>
                              </div>
                              <div className='w-full'>
                                <TextInput
                                  id='quantity'
                                  name='quantity'
                                  type='text'
                                  placeholder='quantity...'
                                  onChange={handleChangeInput}
                                  value={formData.quantity ?? ''}
                                  sizing='md'
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className='flex justify-end pt-2'>
                            <Button
                              disabled={buttonDisabled}
                              type='submit'
                              className='buttonMain'
                              form='jobItemForm'
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
